<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import trainingAttendanceAPI from "@/services/standards/trainingProgram/trainingAttendanceAPI";

/**
 * 1.2.1 — Informe de cobertura anual de capacitaciones (asistencia vs trabajadores activos).
 * Panel derivado (no captura): KPIs + cobertura por capacitación + descarga en PDF branded.
 */
export default {
  page: { title: "Cobertura de capacitaciones" },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "1.2.1 Informe de cobertura de capacitaciones",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        {
          text: "1.2.1 Programa de capacitación",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null}/promocion-prevencion`,
        },
        { text: "Cobertura", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      years: [],
      year: new Date().getFullYear(),
      data: null,
      loading: true,
    };
  },
  methods: {
    rangeYear() {
      const now = new Date().getFullYear();
      for (let i = 2019; i <= now + 1; i++) this.years.push(i);
    },
    covClass(p) {
      if (p >= 80) return "text-success";
      if (p >= 50) return "text-warning";
      return "text-danger";
    },
    fetch() {
      this.loading = true;
      trainingAttendanceAPI.coverage(this.companyID, this.year)
        .then((r) => { this.data = r || null; this.loading = false; })
        .catch(() => { this.loading = false; });
    },
    descargarPdf() {
      window.open(trainingAttendanceAPI.coveragePdfUrl(this.companyID, this.year));
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.rangeYear();
    this.fetch();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-end mb-3">
              <div class="col-md-3">
                <label class="small mb-1">Año</label>
                <select class="form-control" v-model.number="year" @change="fetch">
                  <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                </select>
              </div>
              <div class="col-md-9 text-right">
                <button class="btn btn-secondary mr-1" @click="goBack"><i class="fas fa-arrow-left"></i></button>
                <button class="btn btn-primary" @click="descargarPdf" :disabled="loading">
                  <i class="mdi mdi-file-pdf-box"></i> Descargar informe (PDF)
                </button>
              </div>
            </div>

            <div v-if="loading" class="text-center py-5"><b-spinner variant="primary" /></div>

            <div v-else-if="data">
              <div class="row text-center mb-3">
                <div class="col-md-3">
                  <div class="card border"><div class="card-body py-3">
                    <h3 class="mb-0 text-primary">{{ data.total_activos }}</h3>
                    <span class="text-muted small">Trabajadores activos</span>
                  </div></div>
                </div>
                <div class="col-md-3">
                  <div class="card border"><div class="card-body py-3">
                    <h3 class="mb-0" style="color:#4fc6e1;">{{ data.total_capacitaciones }}</h3>
                    <span class="text-muted small">Capacitaciones</span>
                  </div></div>
                </div>
                <div class="col-md-3">
                  <div class="card border"><div class="card-body py-3">
                    <h3 class="mb-0" style="color:#3f51b5;">{{ data.colaboradores_capacitados }}</h3>
                    <span class="text-muted small">Colaboradores capacitados</span>
                  </div></div>
                </div>
                <div class="col-md-3">
                  <div class="card border"><div class="card-body py-3">
                    <h3 class="mb-0" :class="covClass(data.cobertura_global)">{{ data.cobertura_global }}%</h3>
                    <span class="text-muted small">Cobertura global</span>
                  </div></div>
                </div>
              </div>

              <div v-if="!data.total_capacitaciones" class="alert alert-info">
                No se registraron capacitaciones en el año {{ year }}.
              </div>

              <template v-else>
                <h5 class="text-primary">Cobertura por capacitación</h5>
                <div class="table-responsive">
                  <table class="table table-striped border-bottom">
                    <thead>
                      <tr>
                        <th class="text-center">N°</th>
                        <th>Capacitación</th>
                        <th class="text-center">Fecha</th>
                        <th class="text-center">Asistentes</th>
                        <th class="text-center">Cobertura</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(d, i) in data.detalle" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td>{{ d.tema }}</td>
                        <td class="text-center">{{ d.fecha }}</td>
                        <td class="text-center">{{ d.asistentes }} / {{ data.total_activos }}</td>
                        <td class="text-center font-weight-bold" :class="covClass(d.cobertura)">{{ d.cobertura }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
